import { Schema as S } from "effect";
import { defineMessageUnion } from "foldkit/message";

import {
	createAttributeSchema,
	deleteAttributeSchema,
	getAttributeSchema,
	updateAttributeSchema,
} from "../../api/commands/attributeSchema";
import { EntityType, ValueType } from "../../api/schemas/attributeSchema";

export const Message = defineMessageUnion({
	CompletedFetchSchema: {
		asOf: S.Option(S.String),
		generation: S.Number,
		result: getAttributeSchema.Result,
	},
	ClickedAddEntry: {},
	ClickedEdit: { id: S.String },
	ClickedDelete: { id: S.String },
	ClickedCancel: {},
	ChangedEntityType: { value: EntityType },
	ChangedKey: { value: S.String },
	ChangedValueType: { value: ValueType },
	ChangedLabel: { value: S.String },
	ChangedDescription: { value: S.String },
	ChangedSubType: { value: S.String },
	ChangedSortOrder: { value: S.String },
	SubmittedForm: {},
	CompletedCreate: {
		generation: S.Number,
		result: createAttributeSchema.Result,
	},
	CompletedUpdate: {
		generation: S.Number,
		result: updateAttributeSchema.Result,
	},
	CompletedDelete: {
		generation: S.Number,
		result: deleteAttributeSchema.Result,
	},
});
export type Message = typeof Message.Type;
